import r, { useState as h } from "react";
import { useTranslation as I } from "react-i18next";
import { PhoneInput as M } from "../../../../../../features/common/components/forms/PhoneInput/PhoneInput.js";
import { TextInput as g } from "../../../../../../features/common/components/forms/TextInput/TextInput.js";
import { Selector as V } from "../../../../../../features/common/components/forms/Selector/Selector.js";
import { Label as b } from "../../../../../../features/common/components/forms/Label/Label.js";
import { Checkbox as F } from "../../../../../../features/common/components/forms/Checkbox/Checkbox.js";
import { ScopeModel as D } from "../../../../../../features/api/models/scope/scope.model.js";
import { useBookingConfirmation as A } from "../../../../../../features/api/repositories/booking/useBookingConfirmation.js";
import { useAuth as $ } from "../../../../../../features/auth/hooks/useAuth.js";
import { tint as H } from "../../../../../../../common/libs/tint.js";
import { Modal as R } from "../../../../../../features/common/components/Modal/Modal.js";
import { StepButton as Z } from "../../StepButton/StepButton.js";
import O from "../../../hooks/customization/useCustomization.js";
import j from "../../Restaurant/Restaurant.js";
import { useBookingStep as q, useBooking as G } from "../context.js";
import { convertDateToLabel as J } from "../../../../../../utils.js";
import m from "../bookingForm.module.scss.js";
function he() {
  var C;
  const [f, k] = h(!1), {
    t
  } = I(), {
    data: {
      bookingItem: i,
      confirmedHour: s
    }
  } = q(), {
    configuration: e,
    getTextTranslations: P
  } = O(), o = P("booking"), {
    isLoading: y,
    mutateAsync: _
  } = A(), {
    customer: n
  } = $(), u = !(n != null && n.profile.marketingPermissions), c = !!(e != null && e.shop.settings.legal.bookingPolicy), {
    back: N,
    form: l,
    setCurrentStep: T,
    setFormValue: d
  } = G(), p = i.zones.map((a) => ({
    label: a,
    value: a
  })), [v, L] = h((C = p[0]) == null ? void 0 : C.value), [B, E] = h(!1), S = p.find((a) => a.value === v), W = H(5e-3, (e == null ? void 0 : e.design.colors.general.highlightBackground) ?? "#222"), x = !!l.people && !!l.day && s && !y && (!n && !!l.name && !!l.phone && !!l.email || !!n) && (c && l.bookingPolicy || !c), w = async () => {
    if (x) {
      E(!1);
      try {
        await _({
          zone: v,
          people: l.people,
          comments: l.observations,
          date: l.day,
          time: s,
          customer: {
            name: l.name,
            email: l.email,
            phone: l.phone,
            externalId: n == null ? void 0 : n.profile.externalId,
            marketingPermissions: u ? l.marketingPermissions : void 0
          },
          scope: new D([], [i.id])
        }), T({
          name: "success",
          data: void 0
        });
      } catch {
        E(!0);
      }
    }
  };
  return /* @__PURE__ */ r.createElement("div", { "data-testid": "confirmation-step" }, /* @__PURE__ */ r.createElement("div", { className: m.title }, /* @__PURE__ */ r.createElement("i", { onClick: () => N(), className: "lni lni-chevron-left" }), (o == null ? void 0 : o.confirmation_title) || t("shopLanding.book.confirmation.title")), /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    j,
    {
      id: i.id,
      name: i.name,
      phone: i.phone,
      address: i.address,
      accent: (e == null ? void 0 : e.design.colors.general.highlightHighlight) ?? "#EA565C"
    }
  )), /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    b,
    {
      preventDefault: !0,
      noPadded: !0,
      textColor: (e == null ? void 0 : e.design.colors.general.highlightText) ?? "#FFF",
      text: (o == null ? void 0 : o.n_of_people) || t("shopLanding.book.nOfPeople")
    },
    /* @__PURE__ */ r.createElement("div", { className: m.confirmationValue }, l.people)
  )), /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    b,
    {
      preventDefault: !0,
      noPadded: !0,
      textColor: (e == null ? void 0 : e.design.colors.general.highlightText) ?? "#FFF",
      text: (o == null ? void 0 : o.day) || t("day")
    },
    /* @__PURE__ */ r.createElement("div", { className: m.confirmationValue }, J(l.day, t("today"), t("tomorrow")))
  )), /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    b,
    {
      preventDefault: !0,
      noPadded: !0,
      textColor: (e == null ? void 0 : e.design.colors.general.highlightText) ?? "#FFF",
      text: (o == null ? void 0 : o.hour) || t("hour")
    },
    /* @__PURE__ */ r.createElement("div", { className: m.confirmationValue }, s)
  )), i.zones.length > 1 && /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    V,
    {
      label: (o == null ? void 0 : o.confirmation_form_area_label) || t("shopLanding.book.confirmation.form.area.label"),
      placeholder: (o == null ? void 0 : o.confirmation_form_area_placeholder) || t("shopLanding.book.confirmation.form.area.placeholder"),
      options: p,
      value: S,
      backgroundColor: W,
      textColor: e == null ? void 0 : e.design.colors.general.highlightText,
      onChange: (a) => L(a == null ? void 0 : a.value),
      noPadded: !0
    }
  )), !n && /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    g,
    {
      noPadded: !0,
      isError: !l.name,
      label: `${(o == null ? void 0 : o.name) || t("name")} *`,
      placeholder: (o == null ? void 0 : o.name_placeholder) || t("name"),
      value: l.name ?? "",
      onChange: (a) => d("name", a.target.value),
      design: {
        textColor: (e == null ? void 0 : e.design.colors.general.highlightText) ?? "#FFF"
      }
    }
  )), /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    M,
    {
      noPadded: !0,
      isError: !l.phone,
      label: `${(o == null ? void 0 : o.phone) || t("phone")} *`,
      placeholder: (o == null ? void 0 : o.phone_placeholder) || t("phone"),
      value: l.phone ?? "",
      onChange: (a, z) => d("phone", z),
      design: {
        textColor: (e == null ? void 0 : e.design.colors.general.highlightText) ?? "#FFF"
      }
    }
  )), /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    g,
    {
      noPadded: !0,
      isError: !l.email,
      type: "email",
      label: `${(o == null ? void 0 : o.email) || t("email")} *`,
      placeholder: (o == null ? void 0 : o.email_placeholder) || t("email"),
      value: l.email ?? "",
      onChange: (a) => d("email", a.target.value),
      design: {
        textColor: (e == null ? void 0 : e.design.colors.general.highlightText) ?? "#FFF"
      }
    }
  ))), /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    g,
    {
      noPadded: !0,
      label: (o == null ? void 0 : o.observations) || t("shopLanding.book.confirmation.form.observations.label"),
      placeholder: (o == null ? void 0 : o.observations_label) || t("shopLanding.book.confirmation.form.observations.placeholder"),
      value: l.observations ?? "",
      onChange: (a) => d("observations", a.target.value),
      design: {
        textColor: (e == null ? void 0 : e.design.colors.general.highlightText) ?? "#FFF"
      }
    }
  )), c && /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    F,
    {
      onLabelClick: () => k(!0),
      label: (o == null ? void 0 : o.bookingPolicy) || t("shopLanding.book.confirmation.bookingPolicy.label") || "",
      onChange: (a) => d("bookingPolicy", a.target.checked),
      checked: l.bookingPolicy,
      design: {
        color: (e == null ? void 0 : e.design.colors.general.highlightText) ?? "#FFF",
        fontSize: 13
      }
    }
  ), /* @__PURE__ */ r.createElement(
    R,
    {
      show: f,
      onClose: () => k(!1),
      design: {
        backgroundColor: e == null ? void 0 : e.design.colors.general.background,
        textColor: e == null ? void 0 : e.design.colors.general.text,
        fontFamily: e == null ? void 0 : e.design.fontFamily
      }
    },
    e == null ? void 0 : e.shop.settings.legal.bookingPolicy
  )), u && /* @__PURE__ */ r.createElement("div", { className: m.inputWrapper }, /* @__PURE__ */ r.createElement(
    F,
    {
      label: (o == null ? void 0 : o.marketing_permissions) || t("shopLanding.book.confirmation.marketing.label") || "",
      onChange: (a) => d("marketingPermissions", a.target.checked),
      checked: l.marketingPermissions,
      design: {
        color: (e == null ? void 0 : e.design.colors.general.highlightText) ?? "#FFF",
        fontSize: 13
      }
    }
  )), /* @__PURE__ */ r.createElement(
    Z,
    {
      buttonProps: {
        onClick: () => w()
      },
      disabled: !x,
      textColor: e == null ? void 0 : e.design.colors.general.primaryButtonText,
      backgroundColor: e == null ? void 0 : e.design.colors.general.primaryButtonBackground
    },
    (o == null ? void 0 : o.confirmation_submit) || t("shopLanding.book.confirmation.submit")
  ), B && /* @__PURE__ */ r.createElement("div", { className: m.error }, (o == null ? void 0 : o.confirm_error) || t("shopLanding.book.error.text")));
}
export {
  he as ConfirmationStep
};
//# sourceMappingURL=ConfirmationStep.js.map
